import React, { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { IconButton, Grid as GridUI, Typography } from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { makeStyles } from '@material-ui/styles';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import { Filtro } from '~/components';
import { resetParams } from '~/store/modules/hooks/actions';

import { Toolbar } from './components';

const useStyles = makeStyles(() => ({
  pagination: {
    marginTop: '3rem',
    display: 'flex',
    alignItems: 'center',

    // justifyContent: 'flex-end',
  },
}));

export default function Grid({
  state,
  read,
  filter,
  reset,
  timeOut,
  component: Component,
  sidebar,
  initials,
  hidden,
  limit,
  unique,
  toolbar,
  changeToolbar,
  onStart,
}) {
  // const classes = useStyles();
  const dispatch = useDispatch();

  const { data, page, pageSize, totalPages, params } = state;

  async function handleGetData() {
    if (onStart) {
      await dispatch(read({ ...params, ...unique, pagesize: limit }));
    }
  }

  useEffect(() => {
    handleGetData();

    if (timeOut) {
      const interval = setInterval(() => {
        handleGetData();
      }, timeOut);

      return () => clearInterval(interval);
    }
  }, [params, onStart]);

  useEffect(() => {
    handleGetData();
  }, []);

  useEffect(() => {
    handleResetRequest();
  }, []);
  const handleResetRequest = useCallback(() => {
    dispatch(resetParams());
  }, [dispatch, resetParams]);

  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
      >
        <Toolbar
          data={toolbar}
          onChangeToolbar={(values) => changeToolbar(values)}
        />

        {!isEmpty(sidebar) && !hidden && (
          <Filtro
            filter={filter}
            params={state.params}
            data={sidebar}
            reset={reset}
            initials={initials}
            unique={unique}
            pageSize={limit}
          />
        )}
      </div>

      {onStart && (
        <GridUI container spacing={3}>
          {data.map((row, index) => (
            <Component key={index} get={() => handleGetData()} {...row} />
          ))}
        </GridUI>
      )}

      {!isEmpty(data) && onStart && (
        <div
          style={{
            marginTop: '3rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <Typography variant="caption">
            {page} de {totalPages}
          </Typography>

          <IconButton
            disabled={page <= 1}
            onClick={() =>
              dispatch(
                filter({ ...params, page: Number(page - 1), pagesize: limit })
              )
            }
          >
            <ChevronLeftIcon />
          </IconButton>

          <IconButton
            disabled={page >= totalPages}
            onClick={() =>
              dispatch(
                filter({ ...params, page: Number(page + 1), pagesize: limit })
              )
            }
          >
            <ChevronRightIcon />
          </IconButton>
        </div>
      )}
    </div>
  );
}

Grid.propTypes = {
  state: PropTypes.objectOf(PropTypes.any).isRequired,
  read: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  filter: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  timeOut: PropTypes.number,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
  sidebar: PropTypes.arrayOf(PropTypes.object),
  initials: PropTypes.objectOf(PropTypes.any),
  hidden: PropTypes.bool,
  limit: PropTypes.number,
  unique: PropTypes.objectOf(PropTypes.any),
  toolbar: PropTypes.arrayOf(PropTypes.any),
  changeToolbar: PropTypes.func,
  onStart: PropTypes.bool,
};

Grid.defaultProps = {
  read: false,
  timeOut: 3000,
  sidebar: [],
  initials: {},
  hidden: false,
  limit: 6,
  unique: {},
  toolbar: [],
  changeToolbar: () => {},
  onStart: true,
};
